import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ECharts from 'vue-echarts'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.config.productionTip = false

Vue.component('v-chart', ECharts)

Vue.use(VueMoment, {
  moment
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
